import { useRecoilValue } from "recoil";
import { isOrderSheetPageCurrencyKrw } from "@/features/order-sheet-sets/recoils/order-sheet-page-store";
import { exchangeCurrencyStore } from "@/shared/store/exchangeCurrencyStore";

/**
 * 오더시트 페이지의 통화 보기 상태(원화 토글 + 환율)를 한곳에서 만든다.
 * 자세히 보기(그리드)와 카드 보기(갤러리)가 같은 값을 써야 단가·합계가 어긋나지 않는다.
 *
 * @param sheetCurrency 시트 통화(lineSheetSet.currency). 비어 있으면 "EUR"로 본다 —
 *   호출하는 쪽에서 실제 상품 가격의 통화로 먼저 폴백해 넘기는 게 좋다.
 */
export default function useOrderSheetCurrency(sheetCurrency?: string | null) {
  const isKrw = useRecoilValue(isOrderSheetPageCurrencyKrw);
  const exchangeCurrencyInfo = useRecoilValue(exchangeCurrencyStore);

  const defaultCurrency = sheetCurrency || "EUR";
  const selectedCurrency = isKrw ? "KRW" : defaultCurrency;
  // 시트 통화 그대로 보면 1, 원화로 보면 시트 통화 → KRW 환율(pathrade_send_rate).
  const exchangeCurrencyValue: number =
    defaultCurrency !== selectedCurrency
      ? exchangeCurrencyInfo[defaultCurrency]?.pathrade_send_rate
      : 1;

  // 행마다 통화가 다를 수 있어(도매가/소매가 등) 가격 하나를 그 통화 기준으로 표기한다.
  // 환율이 없으면 NaN 대신 원래 통화 그대로 둔다.
  const convert = (amount: number, currency: string) => {
    const rate = exchangeCurrencyInfo[currency]?.pathrade_send_rate;
    return isKrw && rate
      ? { amount: Math.round(amount * rate), currency: "KRW" }
      : { amount, currency };
  };

  return {
    isKrw,
    exchangeCurrencyInfo,
    defaultCurrency,
    selectedCurrency,
    exchangeCurrencyValue,
    convert,
  };
}
